import FormattedMessage from 'components/formatters/FormattedMessage';
import Menus from 'components/menu/Menus';
import Pages from 'components/page/Pages';
import { Nav, Tab } from 'react-bootstrap';

export default function SiteConfig() {
  return (
    <div className="static_page site_config">
      <div className="page_container">
        <div className="page_content">
          <section>
            <h1>
              <FormattedMessage id="ADMIN.SITE_CONFIG.TITLE" />
            </h1>
          </section>
          <Tab.Container defaultActiveKey="pages">
            <Nav variant="tabs">
              <Nav.Item>
                <Nav.Link eventKey="pages">
                  <FormattedMessage
                    id="ADMIN.SITE_CONFIG.TAB_PAGES"
                    defaultMessage="Pages"
                  />
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="menus">
                  <FormattedMessage
                    id="ADMIN.SITE_CONFIG.TAB_MENUS"
                    defaultMessage="Menus"
                  />
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="styling">
                  <FormattedMessage
                    id="ADMIN.SITE_CONFIG.TAB_STYLING"
                    defaultMessage="Styling"
                  />
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content className="mt-3">
              <Tab.Pane eventKey="pages">
                <Pages />
              </Tab.Pane>
              <Tab.Pane eventKey="menus">
                <Menus />
              </Tab.Pane>
              <Tab.Pane eventKey="styling">
                <FormattedMessage id="ADMIN.SITE_CONFIG.TAB_STYLING" />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    </div>
  );
}
